<template lang="html">
    <tr>
      <th class="column-vacancy">{{ $tr('common.list.vacancy') }}</th>
      <th class="column-name">{{ $tr('common.list.name') }}</th>
      <th class="column-surname">{{ $tr('common.list.surname') }}</th>
      <th class="column-email">{{ $tr('common.list.email') }}</th>
      <th class="column-phone">{{ $tr('common.list.phone') }}</th>
      <th class="column-inner-outer"></th>
      <th class="column-delete-icon"></th>
    </tr>
</template>

<script>
  export default {
    name: 'process-invites-creation-row-header'
  }
</script>

<style lang="scss" scoped>
  $trhead: #555555;
  th {
    height: initial;
    font-weight: 500;
    color: $trhead;
    padding: 20px 6px 20px 17px;
    position: relative;
    white-space: normal;
    box-sizing: border-box;
    border-bottom: 1px solid $trhead;

    &.column-inner-outer{
        min-width: 120px;
        width: 120px;
    }

    &.column-delete-icon {
      min-width: 60px;
      width: 60px;
    }
  }
</style>
